import { UpdateResponse } from '.';
import { JsonObject } from '../helpers';
import { get as getLocal, remove as removeLocal } from '../local-storage';
import { DatasourceSetting } from '../models/thread';
import { ThreadSettingsModel } from '../models/thread/thread-settings.model';
import {
  CreateUserSettingsModel,
  UserSettingsModel,
} from '../models/user-settings/user-settings.model';
import { AuthProvider } from './auth.service';
import { get, update } from './sp-api.service';

export type UserSettings = {
  thread: ThreadSettingsModel;
};

type LocalSettings = {
  datasources: (DatasourceSetting & { id: string })[];
  agentId: string;
  privateModelId: string;
};

export const getUserSettings = async (): Promise<UserSettingsModel> => {
  const response = await get('/user/profile?namespace=portal').catch((err) => {
    console.error(err);
  });

  if (!response) {
    return new UserSettingsModel();
  }

  return new UserSettingsModel(response as JsonObject);
};

export const getUserSettingsLocal = (): UserSettings | null => {
  if (!AuthProvider.spUserId) {
    return null;
  }

  const localSettings = getLocal(getLocalStorageKey(), true) as LocalSettings;

  if (!localSettings) {
    return null;
  }

  const defaults: UserSettings = {
    thread: new ThreadSettingsModel(),
  };

  if (Array.isArray(localSettings.datasources)) {
    defaults.thread.datasources = localSettings.datasources;
  }

  if (localSettings.agentId) {
    defaults.thread.agentId = localSettings.agentId;
  }

  if (localSettings.privateModelId) {
    defaults.thread.privateModelId = localSettings.privateModelId;
  }

  return defaults;
};

export const removeUserSettingsLocal = (): void => {
  if (!AuthProvider.spUserId) {
    return;
  }

  removeLocal(getLocalStorageKey());
};

export const updateUserSettings = async (settings: UserSettingsModel): Promise<UpdateResponse> => {
  const createModel = new CreateUserSettingsModel(settings);
  return update('/user/profile?namespace=portal', createModel._props);
};

const getLocalStorageKey = (): string => `user-settings-${AuthProvider.spUserId}`;
